// removed by extract-text-webpack-plugin
module.exports = {"featuredLogo":"src-pages-features-integrations-style----card-module---featuredLogo---2zSgX position-absolute","logo":"src-pages-features-integrations-style----card-module---logo---3ivfO"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/features/integrations/style/card.module.css
// module id = 162
// module chunks = 168707334958949